var $name="shell/engine/configureGsap",$path="app/modules/shell/engine/configureGsap.js",$this={$name,$path,};import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function configureGsap() {
  gsap.registerPlugin(Draggable, ScrollToPlugin, ScrollTrigger);
}
